<template>
  <div class="bg-dark-create" :class="[showmodal?'open':'']"></div>
  <div class="form-create-module" :class="[showmodal?'open':'']">
      <div class="modal" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content create-module">
              <div class="modal-header">
                <h5 class="modal-title">Criar Módulo</h5>
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
              </div>
              <div class="modal-body">
                  <div class="form-group">
                      <div class="form-label">
                        <label class="label-form">
                             Nome
                             <v-tooltip text="Campo obrigatório" location="top">
                              <template v-slot:activator="{ props }">
                                <i v-bind="props" class="pi pi-exclamation-circle"></i>
                              </template>
                            </v-tooltip>
                          </label>
                      </div>
                      <div class="form-input">
                          <input v-model="nameModule" type="text" class="form-control" placeholder="Modulo 1...">
                      </div>
                  </div>
              </div>
              <div class="modal-body">
                  <div class="form-group">
                      <label class="label-form">
                          Demostração<v-tooltip text="Campo obrigatório" location="top">
                            <template v-slot:activator="{ props }">
                              <i v-bind="props" class="pi pi-exclamation-circle"></i>
                            </template>
                          </v-tooltip>
                      </label>
                      <select v-model="demo" class="select-mode">
                          <option value="" disabled selected>Selecione o tipo</option>
                          <option value="1">Sim</option>
                          <option value="0">Não</option
                              >
                      </select>
                  </div>
              </div>
              <div class="modal-footer">
                <button type="button"  @click="closetab()" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                <button type="button"  @click="saveModule()" class="btn btn-primary">Salvar</button>
              </div>
            </div>
          </div>
        </div>
 
  </div>
</template>
<script>
import api from '@/utils/modules'
import { mapState } from 'vuex';

export default {
data(){
  return{
      showmodal:'',
      nameModule:'',
      demo:'0',
  }
},
props: {
  show: Boolean, 
},
computed:{
  ...mapState(['token','IdCourse'])
},
methods: {
  closetab() {
    this.showmodal = false; 
    this.$emit('open-tab', this.showmodal)
  },
  opentab(){
      this.show=true;
      this.$emit('open-tab', this.showmodal)
  },
  async createModule(){
    const id = this.$route.params.slug;
    try {
      const obj = {
        "course": {
          "id": this.IdCourse,
        },
        "title": this.nameModule,
        "sample": this.demo,
      }
      const response = await api.createNewModule(obj, this.token);
    } catch (error) {
      console.error('Erro ao criar o modulo', error)
    }
  },
  saveModule(){
    this.createModule();
    this.showmodal = false; 
    this.$emit('open-tab', this.showmodal)
    this.nameModule=null;
    this.demo=null;
  }
},
watch: {
  show(novoValor) {
    this.showmodal = this.show;
  },
  }
};
</script>
<style scoped> 
@import './tabs.css';

.modal-content.create-module .form-group .form-label label {
  display: flex;
  justify-content: flex-start;
  gap: 5px;
}
.modal-content.create-module label.label-form {
  display: flex !important;
  gap: 5px;
  align-items: center;
  font-size: 14px;
}
</style>
